/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createExpm1 } from '../../factoriesAny.js';
export var expm1Dependencies = {
  ComplexDependencies,
  typedDependencies,
  createExpm1
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesExpm1.generated.js
// module id = 6NIl
// module chunks = 3